import React from "react";
import styles from "./InfoCard.module.scss";
import PropTypes from "prop-types";
import { colors } from "../../modules/theme";

import { scaleLinear } from 'd3-scale'
import { interpolateYlOrRd } from "d3-scale-chromatic"

import { TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Table } from '@material-ui/core';

const headCells = [
  { id: 'occpuation', numeric: false, disablePadding: true, label: 'Occupation' },
  { id: 'workers', numeric: true, disablePadding: false, label: 'Number of workers' },
  { id: 'disease', numeric: true, disablePadding: false, label: 'Exposure to disease' },
  { id: 'proximity', numeric: true, disablePadding: false, label: 'Physical p' }
];

const InfoCard = ({ shop, riskAvg, activeCard, clickHandler, tabIndex, numCases, suburbName, suburbs, riskInfo, maxCases, minRisk, maxRisk, latestDate }) => {

  let getColour = (v, min, max) => {
    let cellStyle = { background:"rgba(255, 255, 255, 0.8)" };
    if(v === undefined) {
      cellStyle = { background:"rgba(255, 255, 255, 0.8)" };
    }
    else {
      let cellColour = scaleLinear()
                      .domain([min, max])
                      .range([0, 1])
      const [redVal, greenVal, blueVal] = interpolateYlOrRd(cellColour(v))
                                    .substr(4).slice(0, -1).split(",")
                                    .map(color => parseInt(color, 10));
      cellStyle = {
        background:"rgba("+redVal+", "+greenVal+", "+blueVal+", 0.8)"
      }
    }
    return cellStyle;
  }

  let normalisedRisk = riskAvg;

  return (
    <div
      className={`${styles.sidebarCard} ${
        activeCard ? styles.activeCard : styles.inactiveCard
        }`}
      style={{
        border: "none",
      }}
      onClick={clickHandler}
    >
      <div className={styles.InfoCardStatusContainer}>
        <div style={{cursor: "default", padding: "10px", background: "#eee", borderRadius: 5 }}>
          <div className={styles.statusNum}>
            <p>Occupational risk</p>
            <h4>{normalisedRisk < 0 ? 'N/A' : normalisedRisk}</h4>
          </div>
          <div className={styles.statusDot} style={getColour(riskAvg, minRisk, maxRisk)}></div>
        </div>
        <div style={{cursor: "default", padding: "10px", background: "#eee", borderRadius: 5 }}>
          <div className={styles.statusNum}>
            <p>COVID-19 cases</p>
            <h4><strong>{numCases ? numCases : 0}</strong></h4>
          </div>
          <div className={styles.statusDot} style={getColour(numCases, 0, maxCases)}></div>
        </div>
      </div>
      <p style={{ fontSize:"0.8em", margin: "10px 0 30px", fontStyle:"italic" }}>COVID-19 cases last updated on {latestDate}</p>
      <h4>
        Suburbs
      </h4>
      <p
        style={{
          marginBottom: '20px'
        }}
      >
        {suburbs &&
          // List of suburbs in that postcode, up to 10 
          suburbs.slice(0, 10).map((suburb, i) => {
            if (i === 9) {
              return <span key={suburb + i} title={suburbs.join()}>{`${suburb}...`
              }</span>
            } else if (i === suburbs.length - 1) {
              return (<span key={suburb + i}>{suburb}</span>);
            } else {
              return (<span key={suburb + i}>{`${suburb}, `}</span>);
            }
          })
        }</p>

      <div
        style={{
          marginBottom: '30px'
        }}
      >
        {riskInfo.top_jobs &&
        <div>
          <h4>Top ten occupations</h4>
          <Table style={{ width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Total workers</TableCell>
                <TableCell>Exposure to disease</TableCell>
                <TableCell>Physical proximity</TableCell>
                <TableCell><b>Occpational risk</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                riskInfo.top_jobs.map((job, i) => {
                  let diseaseRisk = job.disease
                  diseaseRisk = diseaseRisk < 0 ? 0 : diseaseRisk
                  let proximityRisk = job.proximity
                  proximityRisk = proximityRisk < 0 ? 0 : proximityRisk
                  let occupationalRisk = (diseaseRisk+proximityRisk)/2

                  return (<TableRow key={job.name + i}>
                    <TableCell><b>{job.name}</b></TableCell>
                    <TableCell>{job.count}</TableCell>
                    <TableCell><div style={getColour(diseaseRisk, 0, 100)}>{diseaseRisk}</div></TableCell>
                    <TableCell><div style={getColour(proximityRisk, 0, 100)}>{proximityRisk}</div></TableCell>
                    <TableCell><div style={getColour(occupationalRisk, 0, 100)}>{occupationalRisk}</div></TableCell>
                  </TableRow>)
                })}
            </TableBody>
          </Table>
        </div>
      }
      </div>

    </div >
  );
};

InfoCard.propTypes = {
  shop: PropTypes.object,
  activeCard: PropTypes.bool,
  clickHandler: PropTypes.func,
  tabIndex: PropTypes.number,
  riskInfo: PropTypes.object,
  numCases: PropTypes.number,
  riskAvg: PropTypes.number,
  maxCases: PropTypes.number,
  maxRisk: PropTypes.number,
  minRisk: PropTypes.number,
  suburbName: PropTypes.string,
  suburbs: PropTypes.array,
  latestDate: PropTypes.string
};

export default InfoCard;



// WEBPACK FOOTER //
// ./src/components/infoCard/InfoCard.js